var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgThird = function SvgThird(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E0F8F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0009 12.8571C14.0009 12.3821 14.4021 12 14.9008 12H24.5001C24.8676 12 25.1976 12.2143 25.3363 12.5393C25.475 12.8643 25.3888 13.2357 25.1226 13.4786L19.5392 18.5714H21.0504C23.7839 18.5714 26 20.6821 26 23.2857C26 25.8893 23.7839 28 21.0504 28H17.6531C16.1757 28 14.8258 27.2036 14.1659 25.9464L14.0946 25.8107C13.8734 25.3857 14.0534 24.8714 14.4958 24.6607C14.9383 24.45 15.482 24.6214 15.7033 25.0429L15.7745 25.1786C16.1307 25.8571 16.8582 26.2857 17.6531 26.2857H21.0504C22.7902 26.2857 24.2001 24.9429 24.2001 23.2857C24.2001 21.6286 22.7902 20.2857 21.0504 20.2857H17.3006C16.9332 20.2857 16.6032 20.0714 16.4645 19.7464C16.3257 19.4214 16.412 19.05 16.6782 18.8071L22.2615 13.7143H14.9008C14.4021 13.7143 14.0009 13.3321 14.0009 12.8571Z",
    fill: "#01878E"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThird, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/third.675e81b6.svg";
export { ForwardRef as ReactComponent };